import {
    Component,
    forwardRef,
    Input,
    OnInit,
    ChangeDetectionStrategy
} from "@angular/core";
import { NG_VALUE_ACCESSOR, FormsModule } from "@angular/forms";
import debounce from "lodash/debounce";
import { ControlValueAccessorBaseComponent } from "../base-component/control-value-accessor-base.component";

@Component({
    providers: [
        {
            multi: true,
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SliderComponent)
        }
    ],
    selector: "rask-slider",
    templateUrl: "./slider.component.html",
    styleUrls: ["./slider.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})
export class SliderComponent extends ControlValueAccessorBaseComponent<number> implements OnInit {
    @Input() min = 0;
    @Input() max = 1;
    @Input() step = 0.1;
    @Input() useLabels = false;

    minValue: string;
    maxValue: string;
    formattedValue: string;

    private debounced: any;

    @Input() viewFormatter = (i: number): string => `${i}`;

    ngOnInit(): void {
        this.formattedValue = this.viewFormatter(this.value);
        this.minValue = this.viewFormatter(this.min);
        this.maxValue = this.viewFormatter(this.max);
    }

    onChangeLocal: any = (val: number) => {
        this.formattedValue = this.viewFormatter(val);
    };

    privateValueChange: any = ($event: any) => {

        if (this.debounced) {
            this.debounced.cancel();
        }

        this.debounced = debounce(() => {
            this.privateValue = $event;
            this.value = this.privateValue;
            this.debounced = undefined;
        }, 200);

        this.debounced();
    };
}
